"use client";

import { type FormEvent, useState } from "react";
import { useRouter } from "next/navigation";

import { authClient } from "@/lib/auth-client";

export function accountNameToEmail(value: string) {
  const accountName = value.trim().toLowerCase();
  return accountName.includes("@") ? accountName : `${accountName}@winenote.local`;
}

export function SignInForm() {
  const router = useRouter();
  const [error, setError] = useState("");
  const [isPending, setIsPending] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError("");
    setIsPending(true);
    const form = new FormData(event.currentTarget);

    try {
      const result = await authClient.signIn.email({
        email: accountNameToEmail(String(form.get("accountName") ?? "")),
        password: String(form.get("password") ?? ""),
      });
      if (result.error) {
        setError("用户名或密码不正确，请重试。");
        return;
      }
      router.replace("/cellar");
      router.refresh();
    } catch {
      setError("暂时无法登录，请稍后再试。");
    } finally {
      setIsPending(false);
    }
  }

  return (
    <form className="mt-8 space-y-5" method="post" onSubmit={handleSubmit}>
      <div>
        <label className="mb-2 block text-sm font-medium" htmlFor="accountName">
          用户名
        </label>
        <input
          className="w-full rounded-xl border border-stone-300 bg-white px-4 py-3 outline-none transition focus:border-rose-900 focus:ring-2 focus:ring-rose-900/15"
          id="accountName"
          name="accountName"
          type="text"
          autoComplete="username"
          required
          disabled={isPending}
        />
      </div>
      <div>
        <label className="mb-2 block text-sm font-medium" htmlFor="password">
          密码
        </label>
        <input
          className="w-full rounded-xl border border-stone-300 bg-white px-4 py-3 outline-none transition focus:border-rose-900 focus:ring-2 focus:ring-rose-900/15"
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          required
          disabled={isPending}
        />
      </div>
      {error ? (
        <p className="text-sm text-red-700" role="alert" aria-live="polite">
          {error}
        </p>
      ) : null}
      <button
        className="w-full rounded-xl bg-rose-950 px-4 py-3 font-medium text-white transition hover:bg-rose-900 disabled:cursor-not-allowed disabled:opacity-60"
        type="submit"
        disabled={isPending}
      >
        {isPending ? "正在登录…" : "登录"}
      </button>
    </form>
  );
}
